<div
  class="flex flex-col h-full md:max-w-[25rem] justify-between p-[1.5rem] rounded-xl shadow-md bg-white border border-vinciGrey-200"
>
  <div class="flex gap-4 items center pb-4">
    @if(photoUrl()) {
    <img
      alt="Contact"
      class="max-w-[4.6875rem] max-h-[4.6875rem] rounded-full"
      [src]="photoUrl()"
    />
    } @else {
    <img
      alt="Default contact"
      class="max-w-[4.6875rem] max-h-[4.6875rem] rounded-full"
      src="assets/images/user/user-contact-card.png"
    />
    }
    <div class="flex flex-col justify-between">
      <h4>{{ name() }}</h4>
      @if(hasText(entity())) {
      <p>{{ entity() }}</p>
      }
      <p>{{ job() }}</p>
    </div>
  </div>
  <div class="flex flex-col gap-1">
    @if(!isInEditMode()){ @if(mail() || phoneNumber()){
    <div class="flex flex-col gap-1">
      @if(location()){
      <p class="flex items-center gap-4 overflow-hidden">
        <icon
          [name]="'location'"
          [size]="'1.25rem'"
          class="flex-shrink-0"
        ></icon>
        <span class="truncate">{{arrayToString(location()!)}}</span>
      </p>
      } @if(languages()){
      <p class="flex items-center gap-4 overflow-hidden">
        <icon
          [name]="'messages'"
          [size]="'1.25rem'"
          class="flex-shrink-0"
        ></icon>
        <span class="truncate">{{arrayToString(languages()!)}}</span>
      </p>
      } @if(mail()){
      <span class="flex gap-4 items-center overflow-hidden"
        ><icon [name]="'mail'" [size]="'1.25rem'" class="flex-shrink-0"></icon>
        <a class="truncate" [href]="'mailto:' + mail()" [title]="mail()"
          >{{mail()}}</a
        ></span
      >
      } @if(bookingLink()){
      <button class="cta text-vinciBlue-600" (click)="openBookingCalendar()">
        <icon
          [name]="'calendar'"
          [size]="'1.25rem'"
          class="flex-shrink-0"
        ></icon>
        <span>{{ 'profile.hrContact.bookingCtaText' | transloco }}</span>
      </button>
      }
    </div>
    } }
  </div>
  @if(isInEditMode()){
  <div class="flex gap-3 items-center self-center pt-4">
    <input
      type="checkbox"
      name="delete"
      id="delete"
      class="w-[1.5rem] h-[1.5rem]"
      (change)="onDeleteRequired()"
    />
    <label for="delete"
      >{{ 'components.contactCard.delete' | transloco }}</label
    >
  </div>
  } @if(allowSaving() && !isSaved()){
  <button class="cta pt-4 text-vinciBlue-600 self-center" (click)="onSave()">
    {{ 'components.contactCard.save' | transloco }}
    <icon [name]="'thumb-up'" [size]="'1rem'"></icon>
  </button>
  } @else if(allowSaving() && isSaved()){
  <button class="cta pt-4 text-vinciBlue-600 self-center" (click)="onUnsave()">
    {{ 'components.contactCard.deleteFromFavorite' | transloco }}
    <icon [name]="'thumb-up-filled'" [size]="'1rem'"></icon>
  </button>
  }
</div>
